import { useState } from 'react';
import { ReactComponent as Info } from './info.svg';
import { ReactComponent as InfoTriangle } from './info-triangle.svg';
import './index.scss';
import cn from 'classnames';

interface IProps {
  info: string;
}

export default function InfoPanel({ info }: IProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  function handleButtonClick(): void {
    setIsOpen(!isOpen);
  }

  return (
    <div className={cn('info-container', { open: isOpen })}>
      <button className="info-button" data-testid="info-panel" onClick={handleButtonClick}>
        <Info className="info-icon" />
      </button>

      <div className="info-panel" data-testid="panel">
        <p className="info-description">{info}</p>
        <InfoTriangle className="info-triangle" />
      </div>
    </div>
  );
}
